export const REF_NAME = 'LOADINGTERM';
export const REF_PATH = 'loadingterm';
export const NAME = 'Laytime term';
